import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Button } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { moveDeviceInTree } from 'console/left-menu/set-device-tree-group/action';
import { findGroupForDevice } from 'console/sortableDeviceTree/utils/group-utils';
import { getGroupsNameWithPath, getKeyForList, } from 'console/left-menu/set-device-tree-group/utils';
import * as lodash from 'lodash';
import { MaterialStringAutocomplete } from 'console/shared/components/fields';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { useBooleanState } from 'shared/hooks/state/boolean';
function getOptions(groups) {
    const groups_name = groups.map((group, index) => ({
        name: group.name,
        id: index.toString(),
    }));
    return [{ name: 'Группы', options: groups_name }];
}
export const useSelectDeviceTreeGroupDialog = () => {
    const device_id = useAppSelector(selectNullableSelectedDeviceId);
    const device_tree = useAppSelector(selectDeviceTree);
    const onSelectGroup = useAction(moveDeviceInTree);
    const [opened, close, open] = useBooleanState(false);
    const ConfirmDialog = useMemo(() => {
        const ConfirmDialogComponent = (props) => {
            const exist_selected_group = findGroupForDevice(device_id, device_tree);
            const groups = getGroupsNameWithPath(device_tree);
            const [new_group_key, setGroupKey] = useState(getKeyForList(exist_selected_group, groups));
            const [path, setPath] = useState({
                old_path: [],
                new_path: [],
            });
            useEffect(() => {
                getKeyForList(exist_selected_group, groups);
            }, [groups, exist_selected_group]);
            const _onConfirm = useCallback(() => {
                onSelectGroup(path);
                close();
            }, [onSelectGroup, path]);
            const handleChange = useCallback((new_value) => {
                setGroupKey(new_value);
                const new_group = groups[parseInt(new_value, 10)];
                //Если нет группы, значит выкидываем в корень
                const new_path = new_group != null ? new_group.path : [];
                //Отправим наверх, что выбрали
                if (!lodash.isEqual(exist_selected_group.path, new_path)) {
                    setPath({ old_path: exist_selected_group.path, new_path });
                }
            }, [setGroupKey, groups, exist_selected_group.path, setPath]);
            return (_jsx(MessageBox, { open: opened, onClose: close, isError: true, footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: close, color: "neutral", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { onClick: _onConfirm, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] }), ...props, children: _jsx(Box, { width: 240, children: _jsx(MaterialStringAutocomplete, { label: "\u041D\u043E\u0432\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430", value: new_group_key, onChange: handleChange, options: getOptions(groups), fullWidth: true, notChosenValue: "-1", notChosenTitle: "\u0411\u0435\u0437 \u0433\u0440\u0443\u043F\u043F\u044B" }) }) }));
        };
        return ConfirmDialogComponent;
    }, [opened, close, device_id, device_tree]);
    return [ConfirmDialog, open];
};
